@if (count > 0) {
  <span class="counter-badge">{{ count }}</span>
}
